import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDLabelText, FDStack,
} from '@facet-wealth/design';
import { CondensedListItem } from 'Packages/FacetDesign/Components/Experimental/CondensedListItem';
import {
  MESSAGE_ROUTE_STATUS_QUERY_FIELD,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters';

const RoutingThreadFilterGroup = ({
  resource, onChange, handleClose,
}) => {
  return (
    <FDStack direction={'column'} spacing={2}>
      <FDLabelText value={resource.meta().field(MESSAGE_ROUTE_STATUS_QUERY_FIELD).attr('prompt')} />
      <FDStack direction={'column'} spacing={1}>
        { resource.meta().field(MESSAGE_ROUTE_STATUS_QUERY_FIELD).options().list()
          .map((option) => {
            const selected = resource.attr(MESSAGE_ROUTE_STATUS_QUERY_FIELD) === option.attr('id');
            return (
              <CondensedListItem
                key={option.attr('id')}
                primaryText={option.attr('prompt')}
                onClick={() => {
                  onChange(selected ? null : option.attr('id'), MESSAGE_ROUTE_STATUS_QUERY_FIELD);
                  handleClose();
                }}
                test={`thread-list-filter-${option.attr('id')}`}
              />
            );
          })}
      </FDStack>
    </FDStack>
  );
};

RoutingThreadFilterGroup.defaultProps = {};

RoutingThreadFilterGroup.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  handleClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RoutingThreadFilterGroup;
